export default (state, action) => {
  return Object.assign({}, state, { order_id: action.order_id });
};
